import type { ReactNode } from "react";
import { CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

type BillingSectionHeaderProps = {
	title: string;
	description: string;
	action?: ReactNode;
	className?: string;
};

export function BillingSectionHeader({
	title,
	description,
	action,
	className,
}: BillingSectionHeaderProps) {
	return (
		<CardHeader className={cn("pb-4", className)}>
			<div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between lg:items-center">
				<div className="min-w-0">
					<CardTitle className="max-w-[32ch] text-balance text-2xl/8 font-bold tracking-tight sm:text-xl/8">
						{title}
					</CardTitle>
					<p className="mt-1 max-w-[48ch] text-pretty text-base/7 text-muted-foreground sm:text-sm/6">
						{description}
					</p>
				</div>
				{action != null ? (
					<div className="w-full min-w-0 shrink-0 sm:w-auto">{action}</div>
				) : null}
			</div>
		</CardHeader>
	);
}
